var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sharePage"},[(_vm.id)?_c('knowledgeDetail',{attrs:{"id":_vm.id,"showViewCount":true,"url":_vm.$apis.common.getKnowledge}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }